/**
 * Tipo: vinculo entre afiliado <-> empresa, con sucursal y categoria.
 *
 * Un afiliado puede tener varias relaciones laborales (con distintas
 * empresas, simultaneamente o a lo largo del tiempo).
 *
 * Para DDJJ: una empresa solo incluye en su nomina mensual a los afiliados
 * con `estado='activa'` y `fecha_baja IS NULL` (o fecha_baja > inicio del periodo).
 */

export type EstadoRelacionLaboral = 'activa' | 'baja';

export interface RelacionLaboral {
  id: string;
  afiliado_id: string;
  empresa_id: string;
  sucursal_id: string | null;
  categoria_id: string | null;
  fecha_alta: string; // ISO date, requerido
  fecha_baja: string | null;
  estado: EstadoRelacionLaboral;
  observaciones: string | null;
  created_at: string;
  updated_at: string;
}

export type RelacionLaboralCreatePayload = Omit<
  RelacionLaboral,
  'id' | 'created_at' | 'updated_at'
>;
export type RelacionLaboralUpdatePayload = Partial<RelacionLaboralCreatePayload>;

/**
 * Relacion laboral enriquecida con datos de la empresa, sucursal y categoria
 * para mostrar en UI sin tener que hacer multiples joins.
 */
export interface RelacionLaboralExpandida extends RelacionLaboral {
  empresa: {
    cuit: string;
    razon_social: string;
  };
  sucursal: {
    denominacion: string | null;
    domicilio: string | null;
  } | null;
  categoria: {
    codigo: string | null;
    descripcion: string;
  } | null;
}

// ===== Catalogos relacionados =====

export interface Sucursal {
  id: string;
  empresa_id: string;
  denominacion: string | null;
  domicilio: string | null;
  telefono: string | null;
  casa_central: boolean;
  activa: boolean;
}

export interface Categoria {
  id: string;
  codigo: string | null;
  descripcion: string;
  activa: boolean;
}

// ===== Helpers de presentacion =====

export const ESTADO_RL_LABELS: Record<EstadoRelacionLaboral, string> = {
  activa: 'Activa',
  baja: 'Baja',
};

export const ESTADO_RL_COLORS: Record<EstadoRelacionLaboral, 'success' | 'default'> = {
  activa: 'success',
  baja: 'default',
};
